import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getMessageFromError } from "../../../shared/welda/services/utilsService";
import errorHandling from "../errorHandling";
import offersService from "./offersService";

const initialState = {
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

export const handle = createAsyncThunk(
  "customerareaOffers/offers",
  async (params, thunkAPI) => {
    try {
      return await offersService.handle(params);
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const offersSlice = createSlice({
  name: "offer",
  initialState,
  reducers: {
    reset: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(handle.pending, (state) => {
        state.isLoading = true;
        state.message = null;
      })
      .addCase(handle.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = null;
      })
      .addCase(handle.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { reset } = offersSlice.actions;
export default offersSlice.reducer;
